import React, { FC } from "react";

import { Button } from "../Button";
import { ArrowRightIcon } from "../Icons";

export interface IStepActionButton {
  isLast?: boolean;
  onNextButtonClick?: () => void;
  actionLabel?: string;
  disabled?: boolean;
  className?: string;
}

export const StepActionButton: FC<IStepActionButton> = ({
  onNextButtonClick,
  actionLabel = "Proceed",
  isLast,
  disabled,
  className,
}) => {
  return (
    <Button
      className={className}
      onClick={onNextButtonClick}
      disabled={disabled}
    >
      {actionLabel}
      {!isLast ? <ArrowRightIcon /> : null}
    </Button>
  );
};

StepActionButton.displayName = "StepActionButton";
